import { menuScrollStrategy } from './theme/utils/scroll-strategy';
const ɵ0 = menuScrollStrategy;
export class AppModule {
}
export { ɵ0 };
